import { getConfig, isEmbedOrIntegration, isInIframe } from '@townsquare/config';
import { location, redirect } from '@townsquare/facade/window';

const ORG_SITE_ROUTE_REGEX = new RegExp(`^/o/(?<orgIdentifier>[0-9a-zA-Z-]+)(/s/(?<siteIdentifier>[a-zA-Z0-9%+-]+))*`);

function getLogInUrl(redirectUrl?: string) {
	const href = redirectUrl || location().href;

	const url = new URL(href);

	// Extract orgId from pathname pattern: /o/{orgId}/...
	const orgId = url.pathname.match(ORG_SITE_ROUTE_REGEX)?.groups?.orgIdentifier;

	const loginUrl = new URL(`${getConfig().atlassianAccountUrl}/login`);
	loginUrl.searchParams.set('continue', href);
	loginUrl.searchParams.set('application', 'atlas');
	if (orgId) {
		loginUrl.searchParams.set('orgId', orgId);
	}

	return loginUrl.toString();
}

export function returnAfterLogin() {
	if (isEmbedOrIntegration() || isInIframe()) {
		// Embeds and Jira Integration needs to handle this differently
		return;
	}
	redirect(getLogInUrl());
}
